package com.islamicmedia.shared.platform

// Web: let the server choose its default https return page; the app refreshes on tab focus.
actual fun platformBillingSuccessUrl(): String? = null
